<template>
  <div class="flex min-h-screen items-center justify-center px-6">
    <StateContainer
      :variant="StateVariant.ERROR"
      :illustration="
        is404 ? IllustrationVariant.HTTP_404 : IllustrationVariant.HTTP_500
      "
      :header="is404 ? '404 Error' : '500 Error'"
      :subheader="
        is404
          ? 'Page not found. Refresh and try again.'
          : 'Internal server error. Please try again later.'
      "
      primary-cta-label="Go to Dashboard"
      @primary-click="handleError"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useErrorStore } from '@/store/use-error-store';
import {
  StateContainer,
  StateVariant,
  IllustrationVariant,
} from '@/views/_components/state-container';

type Props = {
  error?: { statusCode?: number } | Record<string, unknown>;
};
const props = defineProps<Props>();

const errorStore = useErrorStore();
const router = useRouter();

const is404 = computed(() => {
  const propStatus = (props.error as { statusCode?: number } | undefined)
    ?.statusCode;
  return (propStatus ?? errorStore.statusCode) === 404;
});

const handleError = async () => {
  errorStore.clearError();
  await router.push('/');
};
</script>
